import './DeathNotificationConfirmation.scss';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { LFEBeaconButton } from 'components/shared/LFEBeaconComponents';
import { Content, contentConverter } from 'utils/Content';
import { setCanContinueTrue } from 'state/canContinue/CanContinueActions';
import Store from 'state/Store';
import { getSchedulingLink } from 'state/submitNotification/SubmitNotificationSelectors';

const DeathNotificationConfirmation = ({ schedulingLink }) => {
  useEffect(() => {
    Store.dispatch(setCanContinueTrue());
    return () => {
      Store.dispatch(setCanContinueTrue());
    };
  }, []);
  const deathNotificationConfirmationClosing = contentConverter.makeHtml(
    Content.DeathNotificationConfirmationClosing
  );
  return (
    <div className="confirmation-page">
      <p className="dn-page-text-intro">
        {' '}
        {Content.DeathNotificationConfirmationIntro}
      </p>
      {schedulingLink && (
        <LFEBeaconButton slot="action-zone"
                         variant="primary"
                         label="Schedule an Appointment"
                         link-href={schedulingLink}
                         link-target="_blank"
        />
      )}
      <div className="dn-page-subtitle">What's Next?</div>
      <p id="submit_notification"
         className="dn-page-text-intro"
         dangerouslySetInnerHTML={{
          __html: deathNotificationConfirmationClosing,
        }}
        ></p>
    </div>
  );
};

const mapStateToProps = (state) => ({
  schedulingLink: getSchedulingLink(state),
});

export default connect(mapStateToProps)(DeathNotificationConfirmation);


